import type { RouteRecordRaw } from 'vue-router'

import { ensureRootRoutePath, type RedirectRoutePath } from '@/utilities/routers'

const routeResetPasswordName = '/reset'
const routeResetPasswordPath = ensureRootRoutePath(routeResetPasswordName)

const routeResetPassword: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/views/LoginView.vue')
  },
  meta: {
    requireAuth: false,
  },
  name: routeResetPasswordName,
  path: routeResetPasswordPath,
}

const redirectResetPassword: RedirectRoutePath = {
  // use no "name" attribute here, not working with global navigationGuard
  path: routeResetPassword.path,
}

export { redirectResetPassword, routeResetPassword }
